module.exports = __webpack_public_path__ + "229c2d0cce38435356fe3c01c6d6a44d.svg";